var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.footContent)?_c('div',{staticClass:"text-center text-caption py-2 unselect",style:({
    position: 'fixed',
    bottom: 0,
    width: '100%',
    backgroundColor: ("rgba(" + _vm.loginBgColor + "," + _vm.loginBgTransparency + ")"),
    color: _vm.fontColor
  })},[_vm._v(" "+_vm._s(_vm.footContent)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }